const devConfig = {}

devConfig.MerchantConfig = { BASE_API_URL: "https://orderly-eats-backend.onrender.com" }


export default devConfig
